<template>
  <div class="action-container">
    <div class="part-item gift-part-item">
      <a class="gift-action" @click="handleGiftClick" v-if="downloadGift && downloadGift.urlLeft && downloadGift.imageLeft">
        <img class="action-svg" src="@/assets/images/matr1xFireIntro/banner/matr1x_fire_banner_novice_gift.png" alt="">
      </a>
      <a class="gift-action" @click="handleGiftSubscriptionClick"
        v-if="downloadGift && downloadGift.urlRight && downloadGift.imageRight">
        <img class="action-svg" src="@/assets/images/matr1xFireIntro/banner/matr1x_fire_banner_subscription_gift.png"
          alt="">
      </a>
    </div>

    <div class="part-item">
      <a class="download-action" :href="downloadUrl && downloadUrl.appStore" target="_blank">
        <button class="btn">
          <svg-icon icon-class="download_app_store" class-name="action-svg"
            style="width: 36px; height: 43px"></svg-icon>
          <div class="download-resource">
            <span>Download on the</span>
            <span class="large-text">App Store</span>
          </div>
          <img class="mask" src="@/assets/images/matr1xFireIntro/mask_long.png" alt="mask_long" />
        </button>
      </a>
      <a class="download-action" :href="downloadUrl && downloadUrl.googlePlay" target="_blank">
        <button class="btn">
          <svg-icon icon-class="download_google_play" class-name="action-svg"
            style="width: 36px; height: 43px"></svg-icon>
          <div class="download-resource">
            <span>Download on the</span>
            <span class="large-text">Google Play</span>
          </div>
          <img class="mask" src="@/assets/images/matr1xFireIntro/mask_long.png" alt="mask_long" />
        </button>
      </a>
      <el-popover placement="top" popper-class="qrcode-popper" trigger="hover" :visible-arrow="false">
        <img :src="downloadUrl && downloadUrl.qrcode" width="130" height="130" alt="qrcode" />
        <a slot="reference" class="download-action download-qrcode">
          <button class="btn">
            <svg-icon icon-class="matr1x_fire_qrcode" class-name="action-svg"
              style="width: 52px; height: 52px; color: #df7638;"></svg-icon>
            <img class="mask" src="@/assets/images/matr1xFireIntro/mask_short.png" alt="mask_short" />
          </button>
        </a>
      </el-popover>
    </div>

    <GiftDialog ref="giftDialogRef" v-if="downloadGift && downloadGift.imageLeft">
      <a :href="downloadGift.urlLeft" target="_blank">
        <img :src="downloadGift.imageLeft" width="100%" height="auto" alt="" />
      </a>
    </GiftDialog>

    <GiftDialog ref="giftSubDialogRef" v-if="downloadGift && downloadGift.imageRight">
      <a :href="downloadGift.urlRight" target="_blank">
        <img :src="downloadGift.imageRight" width="100%" height="auto" alt="" />
      </a>
    </GiftDialog>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import GiftDialog from "@/views/matr1xFireIntro/dialog/giftDialog";
export default {
  name: "ActionBtns",
  mixins: [responsiveMixin],
  components: { GiftDialog },
  props: {
    downloadUrl: {
      type: Object,
      default: () => { }
    },
    downloadGift: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    handleGiftClick() {
      this.$refs.giftDialogRef.dialogVisible = true;
    },
    handleGiftSubscriptionClick() {
      this.$refs.giftSubDialogRef.dialogVisible = true;
    }
  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>